import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const HomeDailyLessonSaboIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.icon, classObject), src: "/assets/images/icons/home_daily_lesson_sabo.svg" });
};
const styles = StyleSheet.create({
    icon: {
        width: 68,
        height: 63,
        display: 'block',
        flexShrink: 0,
    },
});
